import { Routes } from '@angular/router';

import { buildAppRoutes } from './app.routes-config';

export const routes: Routes = buildAppRoutes();
